// extracted by mini-css-extract-plugin
export var content = "PressLogos-module--content--77f48";
export var list = "PressLogos-module--list--744c4";
export var wrapper = "PressLogos-module--wrapper--de6f7";